<template>
  <div>
    <div class="history--header">
      <h1> {{ title }} </h1>
      <el-button type="success"
                 icon="el-icon-refresh"
                 class="history--header--button"
                 @click="refreshHistory()">
        Recharger l'historique
      </el-button>
    </div>
    <el-card v-if="history && history.length"
             data-test="history">
      <el-row v-for="(historyRow, index) in paginatedHistory" v-bind:key="historyRow.id">
        <HistoryRow :history-row="historyRow"
                    :index="index"></HistoryRow>
      </el-row>
    </el-card>

    <el-card v-if="!history || !history.length"
             data-test="history-not-found"
             class="box-card">
      <h1>
        {{ $t('history.noHistoryFound') }}
      </h1>
    </el-card>
    <el-pagination v-if="this.history && this.history.length"
                   layout="prev, pager, next"
                   :total="this.history.length"
                   @current-change="setPage">
    </el-pagination>
  </div>
</template>

<script>
  import HistoryRow from './HistoryRow/HistoryRow.vue';

  export default {
    components: {
      HistoryRow,
    },
    props: {
      history: Array,
      title: String,
    },
    data() {
      return {
        page: 1,
        pageSize: 10,
      };
    },
    computed: {
      paginatedHistory() {
        return this
          .history
          .slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
      },
    },
    created() {
    },
    methods: {
      refreshHistory() {
        this.$emit('bubbleUpRefreshHistory');
      },
      setPage(val) {
        this.page = val;
      },
    },
  };

</script>

<style lang="stylus">
  .history--header {
    margin 20px
    display flex
    flex-direction row
    align-items center
    justify-content space-between
  }

  .history--header--button {
    height 10%
  }
</style>
